import { useCallback, useMemo, useState } from 'react'

interface UseHoverCallbacks {
    onMouseEnter: () => void
    onMouseLeave: () => void
}

type UseHoverValues = [boolean, UseHoverCallbacks]

export const useHover = (): UseHoverValues => {
    const [hovered, setHovered] = useState(false)

    const onMouseEnter = useCallback(() => {
        setHovered(true)
    }, [])

    const onMouseLeave = useCallback(() => {
        setHovered(false)
    }, [])

    return useMemo(
        () => [hovered, { onMouseEnter, onMouseLeave }],
        [hovered, onMouseLeave, onMouseEnter]
    )
}
